<template>
  <v-flex :class="align">
    <v-btn icon @click.stop="openUrl">
      <v-icon color="blue-grey">open_in_new</v-icon>
    </v-btn>
  </v-flex>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    align: {
      type: String,
      default: "text-xs-right"
    }
  },
  methods: {
    /**
     * Open the url in a new tab.
     */
    openUrl() {
      window.open(this.url, "_blank");
    }
  }
};
</script>
